module.exports = __webpack_public_path__ + "static/r_yi.138bcca0.svg";